<template>
  <ul
    class="sceneActionReportBody"
    @click.stop="$event.stopPropagation()"
  >
    {{ dataFormat(scenceInfo) }}
    <li
      v-for=" (action, index) in actionReport"
      :key="index"
      class="sceneActionReportList"
    >
      <div class="sceneActionReportAction">
        <div
          v-for=" (tag, tagsIndex) in action['tags']"
          :key="'tags'+tagsIndex"
          class="sceneActionReportActionLi"
        >
          <span
            v-for=" (value, valueIndex) in tag['Values']"
            :key="'value'+valueIndex"
            class="sceneActionReportActionSpan"
          >
            {{ value["Name"]+(value["Name"]!=''?':':'')+(value["DefaultValueName"]!=null?value["DefaultValueName"]:(value["DefaultValue"]+value["ParaUnit"])) }}
          </span>
        </div>
      </div>
      <div
        class="sceneActionReportSkuList"
        style="width:100%, border:solid 1px red;"
      >
        <div
          v-for=" (sku, skuIndex) in action['sku']"
          :key="'sku'+skuIndex"
          class="sceneActionReportSku"
        >
          <div
            v-if="action['tag'] != 'Delete'"
            class="sceneActionReportSkuLeft"
          >
            <!-- <img v-if="sku['ClassSku'] != null" class="card_img" :src="'/static/device/icon/' + sku['ClassSku'] + '.png'" /> -->
            <img
              v-if="sku['ClassSku'] != null"
              class="card_img"
              :src="getClassSkuImage(sku,'on')"
            >
          </div>
          <div
            class="sceneActionReportSkuRight"
            :style="action['tag'] != 'Delete'?'':'width:100%'"
          >
            <span
              v-for=" (device, deviceIndex) in sku['deviceList']"
              :key="'device'+deviceIndex"
            >
              {{ device["ChildId"] != 65535?(device["ChildName"]+' '):'' }}{{ device["DeviceName"] }}
            </span>
          </div>
        </div>
      </div>
    </li>
    <div style="position: absolute;top: 0;right: 0;">
      <i
        class="el-icon-close"
        style="padding:0;"
        @click="handleCloseSceneActionReport"
      />
    </div>
  </ul>
</template>
<script>
import { FindActionAbility } from '@/axios/IDevice.js';
import { FindScene } from '@/axios/IScene.js';
import {getSenceShowMode} from '@/utils/utils'

export default {
  props:{
    scenceInfo:{
      type: Object,
      default: null
    }
  },
  data(){
    return{
      SceneNo: null,
      scenlist:null, //通过接口获取的场景配置详情
      checkeddata: [], //选中的设备卡
      actionReport: [], //能力分析报告绑定数据[{tag:'[{MsgType:KeyId,Values:[{KeyId:'',DefaultValue:'',ParaUnit:''}]}]',sku:[{sku:'',deviceList:[]}]}]
    };
  },
  mouted(){

  },
  methods:{
    getSenceShowMode,
    handleCloseSceneActionReport(){
      this.$emit('handleCloseSceneActionReport');
    },
    dataFormat(item){
      if(item != null){
        if( this.SceneNo != item["SceneNo"]){
          this.SceneNo = item["SceneNo"];
          this.doFindScene();
        }
      }
    },
    /* 编辑模式查询场景
		*/
		doFindScene(){
      //场景配置详情
      this.checkeddata = [];
			var para={sceneNo:this.SceneNo};
			FindScene(para,this.functionDoFindScene);
			para=null;
		},
    /* 编辑模式查询场景 接口返回数据处理
		* rs 接口返回数据包
		*/
		functionDoFindScene(rs){
			if (rs.StatusCode == this.$store.state.rightStatusCode) {
				// this.parameters.GpNo=rs.Result.GpNo;
				// this.parameters.ConfigStatus=rs.Result.ConfigStatus;
				// this.parameters.ParentAreaNames=rs.Result.ParentAreaNames;
				this.scenlist=rs.Result;
				// this.nameValue=this.scenlist.SecneName;
				// this.selectvalue= this.scenlist.SceneType;
				this.addcheckdata(rs.Result.DeviceList);
			}
		},
		/* 获得场景下设备的action能力
		* val 场景下所有的设备
		*/
		addcheckdata(val){
      if(val != null){
        var actionReportObj,deviceObj;
        //用于编辑进来以后绑定
        val.forEach(item => {

            item.ChildId=item.ChannelId;
            item.ChildName=item.ChannelName!=null?item.ChannelName:'';
            deviceObj = {
              VDeviceId: item.VDeviceId,
              ChildId: item.ChannelId,
              DeviceName: item.DeviceName,
              AreaName: item.AreaName,
              ActionType:item.ActionType,
              ClassSku:item.ClassSku,
              ChildName:item.ChildName,
              IsDel:item.IsDel,
              ActionList: []
            };
            this.checkeddata.push(deviceObj);
          if(item.IsDel != true){
            this.doFindActionAbility(item);
          }else{
            this.makeActionDevice(deviceObj);
          }
        });
      }
    },
		/* 获得设备能力
		* item 设备对象
		*/
		doFindActionAbility(item, isall) {
			var para = { vDeviceId: item.VDeviceId,ChildId: item.ChildId,classSku:item.ClassSku,isall:isall};
			FindActionAbility(para, this.functionDoFindActionAbility);
			para = null;
		},
		/* 查询设备能力 接口返回数据处理
		* rs 接口返回数据包
		* params 传递的接口参数
		*/
		functionDoFindActionAbility(rs, params) {

			if (rs.StatusCode == this.$store.state.rightStatusCode) {
				this.checkeddata.forEach(item => {
					//console.log(item);  //ChildId
					if (item.VDeviceId == params.vDeviceId&&item.ChildId==params.ChildId) {
						if(rs.Result){
							if(rs.Result.ActionList){
                item.ischeck = true; //默认选中
                item.ActionList =this.functionfilter(rs.Result.ActionList,params.vDeviceId,params.ChildId) ;
                if(params["isall"] == true){
                  item.ActionList.forEach(model=>{
                    model.ischeck = true;
                  });
                }
							}
						}
					}
        });
			  this.hasaction();
      }
		},
		/* 检查设备是否有action
		*/
		hasaction(){
			//检查设备是否有action
			if(this.checkeddata.length>0){
        let totalNum = 0;
				this.checkeddata.forEach(n=>{
					if(n.ActionList.length>0){
            this.isconcle=true;
            totalNum++;
					}
        })
        // if(totalNum == this.checkeddata.length){
          this.makeActionReport(this.checkeddata);
        // }
			}
		},
		/* 格式化action数据
		*/
		functionfilter(arry,vDeviceId,childId) {
      
			//筛选数组 将不显示的对象去除  DefaultValue格式化转成int
				arry.forEach(model => {
					model.ischeck=false; //默认选中
					for (let i = 0; i < model.Values.length; i++) {
						if (!model.Values[i].IsShow) {
						}else{
							if(this.scenlist){
								this.scenlist.DeviceList.forEach(t=>{
                  //给action赋初始值
									if(t.VDeviceId==vDeviceId&&t.ChannelId==childId){
										t.ActionList.forEach(m=>{
											if(m.MsgType==model.MsgType){
												model.ischeck=true;
												m.Values.forEach(n=>{
													model.Values.forEach(y=>{
														if(n.KeyId==y.KeyId && y["chanded"] != true){
															// y.DefaultValue= this.contorlLightInforValue(y,n.Value);  //待定
															y.DefaultValue=Number(n.Value);
														}
													})
												})
											}else{
                        model.ischeck=false;
                      }
										})
									}
								})
							}

              this.LightActionValueReady(model,i);
              model.Values[i]["chanded"] = true;

							if(model.Values[i].ValueType=="UIControl_RadioboxList"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_SliderAndInput"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_Slider"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_Switch"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_Bright"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_ColorTemperature"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_UpAndDown"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_MotorTrace_Slider" || model.Values[i].ValueType=="UIControl_MotorVerticalTrace_Slider"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}else if(model.Values[i].ValueType=="UIControl_MotorAngle_Slider"){
								model.Values[i].DefaultValue=Number(model.Values[i].DefaultValue);
							}
						}
					}
        });

				return arry;
    },
    makeActionDevice(deviceObj, tag){
      tag = tag || "Delete";
      var actionReportObj = this.actionReport.find(_tag => {return _tag["tag"] == tag;});
      if(actionReportObj == null){
        this.actionReport.push({
          "tag":tag,
          "tags":[{"MsgType":tag,"Values":[{"KeyId":'',"Name":'',"DefaultValue":tag,"ParaUnit":''}]}],
          "sku":[{'ClassSku':deviceObj["ClassSku"],'deviceList':[deviceObj]}]
        });
      }
    },
    makeActionReport(actionList){
      this.actionReport = [];
      if(actionList instanceof Array){
        var deviceObj, tag, tags, values, value, _obj, sku;
        var actionReportObj;

        actionList.forEach( device => {
          deviceObj = {
            "VDeviceId":device["VDeviceId"],
            "ClassSku":device["ClassSku"],
            "DeviceName":device["DeviceName"],
            "ChildName":device["ChildName"],
            "ChildId":device["ChildId"]
          };
          if(device["IsDel"] != true){
            if(device["ActionList"] != null && device["ActionList"].length>0){
              tags = [];
              device["ActionList"].forEach( action => {

                values = [];
                if(getSenceShowMode(action) && action["ischeck"] == true){
                // if(action["ShowMode"] == 3 && action["ischeck"] == true){
                  action["Values"].forEach( _value => {
                    if(_value["IsShow"] == true){
                      
                      value = {
                        "KeyId":_value["KeyId"],
                        "DefaultValue":_value["DefaultValue"],
                        "Name":_value["Name"],
                        "ParaUnit":_value["ParaUnit"]
                      };
                      if(_value["EnumValue"] instanceof Array && _value["EnumValue"].length>0){
                        _obj = _value["EnumValue"].find( _enum => {return _enum["Value"] == _value["DefaultValue"];});
                        if(_obj != null){value["DefaultValueName"] = _obj["Name"];}
                      }
                      if(_value["Type"] != null && _value["Type"].indexOf("0x03")!=-1){
                        value["ParaUnit"] = '%';
                      }
                      values.push(value);
                    }
                  });
                }
                if(values.length>0){
                  tags.push({
                    "MsgType":action["MsgType"],
                    // "Desc":action["Desc"],
                    "Values":values
                  });
                }
              });
              if(tags.length>0){
                tag = JSON.stringify(tags);
                actionReportObj = this.actionReport.find(_tag => {return _tag["tag"] == tag;});
                if(actionReportObj == null){
                  this.actionReport.push({
                    "tag":tag,
                    "tags":tags,
                    "sku":[{'ClassSku':deviceObj["ClassSku"],'deviceList':[deviceObj]}]
                  });
                }else{
                  sku = actionReportObj["sku"];
                  sku = sku.find(_sku => { return _sku["ClassSku"] == deviceObj["ClassSku"];});
                  if(sku == null){
                    actionReportObj["sku"].push({'ClassSku':deviceObj["ClassSku"],'deviceList':[deviceObj]})
                  }else{
                    sku["deviceList"].push(deviceObj);
                  }
                }
              }
            }
          }else{
            this.makeActionDevice(deviceObj);
          }
        });
      }

      deviceObj = null;
      tag = null;
      tags = null;
      values = null;
      value = null;
      _obj = null;
      sku = null;
      actionReportObj = null;


    }
  }
};
</script>
<style lang="scss" scoped>
.sceneActionReportBody{
  width: 370px;
  max-height: 300px;
  padding: 10px;
  background: #F7F9FC;
  font-size:12px;
  line-height: 24px;
  overflow: auto;
  .sceneActionReportList{
    display: inline-block;
      width: 100%;
      border-bottom: dashed 1px #DDE2EA;
      margin-bottom: 15px;
      padding-bottom: 15px;
    .sceneActionReportAction{
      color: #777777;
      display: inline-block;
      .sceneActionReportActionLi{
        float: left;
        margin: 0 10px;
        height: max-content;
        .sceneActionReportActionSpan{
          word-break: keep-all;
        }
      }
    }
    .sceneActionReportSkuList{
      word-break: keep-all;
      color: #8A94A4;
      border: solid 1px #DDE2EA;
      background: #FEFEFE;
      padding: 5px;
      box-shadow:0px 16px 35px 0px rgba(19,110,241,0.06);
      .sceneActionReportSku{
        display: inline-block;
        width: 100%;
        overflow: hidden;
        .sceneActionReportSkuLeft{
          float: left;
          width: 35px;
          padding: 0 5px;
          text-align: center;
          .card_img{
            width: 20px;
            height: 20px;
          }
        }
        .sceneActionReportSkuRight{
          float: right;
          width: calc(100% - 50px);
          span{
            margin: 0 5px;
          }
        }
      }

    }

  }
}
</style>


